import { triniumApi } from '@api/Trinium/slice';
import { Tractor, transformTractorResponse } from './types';

const tractorsSlice = triniumApi.injectEndpoints({
	endpoints: (builder) => ({
		fetchTractors: builder.query<Tractor[], string>({
			query: (terminalNumber) => ({
				url: `${terminalNumber}/tractors`
			}),
			transformResponse: transformTractorResponse,
			keepUnusedDataFor: 180,
			providesTags: (result) => {
				if (!result) return [];

				// We are providing tags for the driver/tractor combination so that
				// a refresh can be determined should the driver be assigned a new tractor
				return [
					...result.map(({ id }) => ({
						type: 'tractors' as const,
						id: id
					}))
				];
			}
		})
	})
});

export const { useFetchTractorsQuery, useLazyFetchTractorsQuery } = tractorsSlice;
